import Vue from "vue";
import axios from "axios";

const EventBus = new Vue({
  data() {
    return {
      inventory: [],
      options: {},
      requestInventoryCallbacks: [],
      requestInventoryStatus: "WAITING_REQUEST",
      vehicleMatcher: {
        vehicle: null,
      },
    };
  },
  created() {
    window.addEventListener("load", this.onWindowLoad);
  },
  methods: {
    onWindowLoad() {
      var ts = Date.now();

      var url = window.location.href;
      if (!url.includes("local")) {
        axios
          .get(
            "/wp-content/themes/base/resources/assets/styles/build/mix-manifest.json?v=" +
              ts
          )
          .then((response) => {
            document.getElementById("child-theme-styles-css").href =
              "/wp-content/themes/base/resources/assets/styles/build/" +
              response.data["/dealer.css"];
            document.getElementById("preload-child-css").href =
              "/wp-content/themes/base/resources/assets/styles/build/" +
              response.data["/dealer.css"];
          })
          .catch(() => {});
      }
    },
    tryGetFormSubmission() {
      wp.ajax
        .post("get_leadbox_ninja_forms_after_submission")
        .done((response) => {})
        .fail(() => {});
    },
    tryGetInventoryFrom(target, callback, params) {
      wp.ajax
        .post("get_leadbox_inventory_from_" + target, { params: params })
        .done((response) => {
          this.inventory = JSON.parse(response);
          callback(true);
        })
        .fail(() => {
          callback(false);
        });
    },
    httpRequestInventory(contentdir, callback, gutembergOptions) {
      switch (this.requestInventoryStatus) {
        case "WAITING_REQUEST": {
          this.requestInventoryStatus = "REQUESTING_INVENTORY";
          this.getUnfilteredInventory(this)
            .then((unfilteredInventory) => {
              this.inventory = unfilteredInventory;
              this.options = gutembergOptions;
              this.gutembergOptionsFiltering();
              this.requestInventoryStatus = "REQUEST_SUCCESSFULLY_COMPLETED";

              const inventoryData = JSON.parse(JSON.stringify(this.inventory));
              callback(inventoryData);
            })
            .catch(() => {
              this.requestInventoryStatus = "REQUEST_FAILED";
              callback([]);
            })
            .finally(() => {
              this.sendRemainingCallbacks(this.inventory);
            });
          break;
        }
        case "REQUESTING_INVENTORY":
          this.requestInventoryCallbacks.push({ callback, gutembergOptions });
          break;
        case "REQUEST_SUCCESSFULLY_COMPLETED": {
          const inventoryData = JSON.parse(JSON.stringify(this.inventory));
          callback(inventoryData);
          break;
        }
        case "REQUEST_INVENTORY_FAILED":
          callback([]);
          break;
      }
    },
    getUnfilteredInventory(vueThis) {
      return new Promise(function (resolve, reject) {
        sessionStorage.removeItem("unfilteredInventory");
        
        let existsLastUpdate = sessionStorage.getItem("lastUpdateInventoryJSON");
        let needsUpdate = EventBus.needsUpdateJSONTimestamp(5, "Inventory");

        let lang = document.documentElement.lang;
        var lg = "";

        if (lang && lang == "fr-CA") {
          lg = "_fr";
          sessionStorage.setItem("lbxLang", lang);
        } else if (lang && lang == "en-CA") {
          sessionStorage.setItem("lbxLang", lang);
        }

        vueThis
          .checkIndexedDBExists("lbx-inventory", "inventory")
          .then((response) => {
            if (!response || needsUpdate || !existsLastUpdate) {
              console.warn("LBX: Inv has no response or 5 mins has passed or no lastUpdateInventoryJSON");

              axios.get("/wp-content/uploads/data/inventory" +lg +".json?v=" +EventBus.getJSONTimestamp(5, "Inventory"))
                .then((response) => {
                  vueThis
                    .storeInventoryData(response.data.vehicles)
                    .then(() => {
                      resolve(response.data.vehicles);
                    })
                    .catch((error) => {
                      resolve(response.data.vehicles);
                    });
                })
                .catch((error) => {
                  reject();
                });
            } else {
              console.warn("LBX: Inv has response or 5 mins has not passed");

              vueThis
                .getInventoryData()
                .then((response) => {
                  resolve(response);
                })
                .catch((error) => {
                  reject();
                });
            }
          });

        //}
      });
    },
    isUnfilteredInventoryOnSessionStorage() {
      if (sessionStorage.getItem("unfilteredInventory")) return true;
      else return false;
    },
    isLangOnSessionStorage() {
      if (sessionStorage.getItem("lbxLang")) return true;
      else return false;
    },
    storeUnfilteredInventoryOnSessionStorage(inventory) {
      var inventoryString = JSON.stringify(inventory);

      try {
        sessionStorage.setItem("unfilteredInventory", inventoryString);
      } catch (e) {
        console.log("Error saving to sessionStorage: " + e);
      }
    },
    getUnfilteredInventoryFromSessionStorage() {
      if (this.isUnfilteredInventoryOnSessionStorage()) {
        return JSON.parse(sessionStorage.getItem("unfilteredInventory"));
      } else {
        return [];
      }
    },
    getLangFromSessionStorage() {
      if (this.isLangOnSessionStorage()) {
        return sessionStorage.getItem("lbxLang");
      } else {
        return false;
      }
    },
    initializeIndexedDB() {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open("lbx-inventory", 2);

        request.onupgradeneeded = (event) => {
          const db = event.target.result;
          db.createObjectStore("inventory", { keyPath: "id" });
        };

        request.onsuccess = (event) => {
          const db = event.target.result;
          resolve(db);
        };

        request.onerror = (event) => {
          reject(event.target.error);
        };
      });
    },
    storeInventoryData(data) {
      return new Promise((resolve, reject) => {
        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readwrite");
            const store = transaction.objectStore("inventory");

            transaction.oncomplete = () => {
              resolve();
            };

            transaction.onerror = (event) => {
              reject(event.target.error);
            };

            // Limpiar datos antiguos del inventario
            store.clear();

            data.forEach((vehicle) => {
              store.add(vehicle);
            });
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    getInventoryData() {
      return new Promise((resolve, reject) => {
        this.initializeIndexedDB()
          .then((db) => {
            const transaction = db.transaction("inventory", "readonly");
            const store = transaction.objectStore("inventory");
            const request = store.getAll();

            request.onsuccess = (event) => {
              resolve(event.target.result);
            };

            request.onerror = (event) => {
              reject(event.target.error);
            };
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    checkIndexedDBExists(dbName, storeName) {
      return new Promise((resolve, reject) => {
        const request = indexedDB.open(dbName);

        request.onsuccess = (event) => {
          const db = event.target.result;
          const objectStoreNames = db.objectStoreNames;

          if (objectStoreNames.contains(storeName)) {
            db.close();
            resolve(true);
          } else {
            db.close();
            resolve(false);
          }
        };

        request.onerror = () => {
          resolve(false);
        };

        request.onupgradeneeded = () => {
          resolve(false);
        };

        request.onblocked = () => {
          reject(
            new Error("La base de datos está bloqueada por otra transacción")
          );
        };
      });
    },
    sendRemainingCallbacks(inventory) {
      this.requestInventoryCallbacks.forEach((cb) => {
        this.inventory = inventory;
        this.options = cb.gutembergOptions;
        this.gutembergOptionsFiltering();
        cb.callback(this.inventory);
      });
    },
    checkValidCDN(url) {
      let cdns = [
        "cardealerstg.blob.core.windows.net",
        "dealerphotocdn.azureedge.net",
        "dealerphoto.blob.core.windows.net",
      ];
      for (var i = 0; i < cdns.length; i++) {
        if (url.toLowerCase().indexOf(cdns[i]) !== -1) {
          return true;
        }
      }
      return false;
    },
    gutembergOptionsFiltering() {
      this.filterVehicles();
      this.sortInventory({
        field: this.options.sort_by,
        order: this.options.sort_by_condition,
        fieldSecondary: this.options.sort_by_secondary,
        orderSecondary: this.options.sort_by_condition_secondary,
      });
      this.limit();
    },
    limit() {
      if (this.options.limit > 0)
        this.inventory = this.inventory.slice(0, this.options.limit);
    },
    sortInventory(payload) {
      if (payload.field === "make (custom)") {
        let uniqueMakes = this.inventory
          .map((item) => item.make)
          .filter((value, index, self) => self.indexOf(value) === index);
        let makesOrder = this.options.sort_makes;

        makesOrder = this.arrayUnique(makesOrder.concat(uniqueMakes));
        makesOrder = makesOrder.map((element) => {
          return element.toLowerCase();
        });

        const numericFields = ['year', 'price', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];

        const SortingPrioritize = (PrioList = [], secondaryField = null, secondaryOrder = null) => {
          return (itemA, itemB) => {
            let a = itemA.make;
            let b = itemB.make;
            let aPos = PrioList.indexOf(a.toLowerCase()),
              bPos = PrioList.indexOf(b.toLowerCase());

            let makeComparison = aPos > -1 && bPos > -1
              ? aPos - bPos
              : aPos > -1
              ? -1
              : bPos > -1
              ? +1
              : a - b;

            // If makes are equal, apply secondary sort
            if (makeComparison === 0 && secondaryField && secondaryOrder && secondaryField !== 'none' && secondaryOrder !== 'none') {
              let valueA = itemA[secondaryField];
              let valueB = itemB[secondaryField];

              // Convert to number if secondary field is numeric
              if (numericFields.includes(secondaryField)) {
                valueA = (valueA === null || valueA === undefined || valueA === '') ? 0 : parseFloat(valueA);
                valueB = (valueB === null || valueB === undefined || valueB === '') ? 0 : parseFloat(valueB);
                valueA = isNaN(valueA) ? 0 : valueA;
                valueB = isNaN(valueB) ? 0 : valueB;
              }

              // Special handling for price: move $0 to the end (both asc and desc)
              if (secondaryField === 'price') {
                if (valueA === 0 && valueB !== 0) return 1;  // A is 0, move to end
                if (valueA !== 0 && valueB === 0) return -1; // B is 0, move to end
                if (valueA === 0 && valueB === 0) return 0;  // Both 0, equal
              }

              if (valueA < valueB) {
                return secondaryOrder == "asc" ? -1 : 1;
              }
              if (valueA > valueB) {
                return secondaryOrder == "asc" ? 1 : -1;
              }
              return 0;
            }

            return makeComparison;
          };
        };

        this.inventory.sort(SortingPrioritize(makesOrder, payload.fieldSecondary, payload.orderSecondary));
      } else if(payload.field === 'stocknumber (custom)' || payload.field === 'stocknumber_custom'){
        // LBT-1453: promote the dealer-defined stocks to the top (in list order);
        // the rest of the inventory follows, sorted by the page's secondary sort
        // (payload.fieldSecondary/orderSecondary) — fallback: natural stocknumber asc.
        var orderArr = this.options.sort_stocks;
        if (!Array.isArray(orderArr) || orderArr.length === 0) {
          var stockCsv = this.options.stock;
          if (typeof stockCsv === 'string' && stockCsv && stockCsv !== 'all') {
            orderArr = stockCsv.split(',').map(function(s){ return s.trim(); }).filter(Boolean);
          } else {
            orderArr = [];
          }
        }
        var positions = {};
        orderArr.forEach(function(s, i){ positions[s] = i; });
        var dir = (payload.order === 'desc') ? -1 : 1;

        var inList = [];
        var outList = [];
        this.inventory.forEach(function(v){
          if (v && v.stocknumber != null && (v.stocknumber in positions)) {
            inList.push(v);
          } else {
            outList.push(v);
          }
        });
        inList.sort(function(a, b) {
          var pa = positions[a.stocknumber];
          var pb = positions[b.stocknumber];
          if (pa === pb) return 0;
          return pa < pb ? -dir : dir;
        });

        var hasSecondary = payload.fieldSecondary && payload.orderSecondary
          && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none';
        var restField = hasSecondary ? payload.fieldSecondary : 'stocknumber';
        var restOrder = hasSecondary ? payload.orderSecondary : 'asc';
        var restNumericFields = ['year', 'price', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];
        var restIsNumeric = restNumericFields.indexOf(restField) !== -1;
        var restIsNaturalString = (restField === 'stocknumber' || restField === 'vin');
        outList.sort(function(a, b){
          var av = a[restField];
          var bv = b[restField];
          if (restIsNumeric) {
            av = (av === null || av === undefined || av === '') ? 0 : parseFloat(av);
            bv = (bv === null || bv === undefined || bv === '') ? 0 : parseFloat(bv);
            if (isNaN(av)) av = 0;
            if (isNaN(bv)) bv = 0;
            if (restField === 'price') {
              if (av === 0 && bv !== 0) return 1;
              if (av !== 0 && bv === 0) return -1;
            }
            if (av === bv) return 0;
            return restOrder === 'asc' ? (av < bv ? -1 : 1) : (av < bv ? 1 : -1);
          }
          if (restIsNaturalString) {
            var as = av == null ? '' : String(av);
            var bs = bv == null ? '' : String(bv);
            if (as === '' && bs !== '') return 1;
            if (as !== '' && bs === '') return -1;
            var cmp = as.localeCompare(bs, undefined, { numeric: true, sensitivity: 'base' });
            if (cmp === 0) return 0;
            return restOrder === 'asc' ? cmp : -cmp;
          }
          if (av < bv) return restOrder === 'asc' ? -1 : 1;
          if (av > bv) return restOrder === 'asc' ? 1 : -1;
          return 0;
        });

        this.inventory = inList.concat(outList);

      } else if(payload.field === 'stocknumbers'){

        this.inventory.sort((a, b) => {
          const validOrders = ['asc', 'desc'];
          let order = (payload && payload.order || 'asc').toLowerCase();

          if (!validOrders.includes(order)) {
              order = 'asc';
          }
      
          const getStockNumber = (item) => {
              const stockNumber = item && item.stocknumber;
              return stockNumber === undefined || stockNumber === null ? '' : String(stockNumber);
          };
      
          const stockNumberA = getStockNumber(a);
          const stockNumberB = getStockNumber(b);
      
          const compareStockNumbers = () => {
              const numA = Number(stockNumberA);
              const numB = Number(stockNumberB);
      
              if (!isNaN(numA) && !isNaN(numB)) {
                  return (numA - numB) * (order === 'asc' ? 1 : -1);
              } else {
                  return stockNumberA.localeCompare(stockNumberB) * (order === 'asc' ? 1 : -1);
              }
          };
      
          return compareStockNumbers();
        });
      } else {
        this.inventory.sort((a, b) => {
          // Primary sort
          var nameA = a[payload.field];
          var nameB = b[payload.field];

          // Convert to number if field is numeric
          var numericFields = ['year', 'price', 'mileage', 'numberofpics', 'dryweight', 'grossweight', 'sleepcapacity'];
          if (numericFields.includes(payload.field)) {
            // Handle null, undefined, empty strings more explicitly
            nameA = (nameA === null || nameA === undefined || nameA === '') ? 0 : parseFloat(nameA);
            nameB = (nameB === null || nameB === undefined || nameB === '') ? 0 : parseFloat(nameB);
            // Handle NaN
            nameA = isNaN(nameA) ? 0 : nameA;
            nameB = isNaN(nameB) ? 0 : nameB;
          }

          // Special handling for price asc: move $0 to the end (primary sort)
          if (payload.field === 'price' && payload.order === 'asc') {
            if (nameA === 0 && nameB !== 0) return 1;  // A is 0, move to end
            if (nameA !== 0 && nameB === 0) return -1; // B is 0, move to end
            // Both 0 or both non-zero, continue with normal comparison
          }

          if (nameA < nameB) {
            return payload.order == "asc" ? -1 : 1;
          }
          if (nameA > nameB) {
            return payload.order == "asc" ? 1 : -1;
          }

          // Values are equal, apply secondary sort if provided
          if (payload.fieldSecondary && payload.orderSecondary && payload.fieldSecondary !== 'none' && payload.orderSecondary !== 'none') {
            var nameASecondary = a[payload.fieldSecondary];
            var nameBSecondary = b[payload.fieldSecondary];

            // Convert to number if secondary field is numeric
            if (numericFields.includes(payload.fieldSecondary)) {
              nameASecondary = (nameASecondary === null || nameASecondary === undefined || nameASecondary === '') ? 0 : parseFloat(nameASecondary);
              nameBSecondary = (nameBSecondary === null || nameBSecondary === undefined || nameBSecondary === '') ? 0 : parseFloat(nameBSecondary);
              nameASecondary = isNaN(nameASecondary) ? 0 : nameASecondary;
              nameBSecondary = isNaN(nameBSecondary) ? 0 : nameBSecondary;
            }

            // Special handling for price: move $0 to the end (both asc and desc)
            if (payload.fieldSecondary === 'price') {
              if (nameASecondary === 0 && nameBSecondary !== 0) return 1;  // A is 0, move to end
              if (nameASecondary !== 0 && nameBSecondary === 0) return -1; // B is 0, move to end
              if (nameASecondary === 0 && nameBSecondary === 0) return 0;  // Both 0, equal
            }

            if (nameASecondary < nameBSecondary) {
              return payload.orderSecondary == "asc" ? -1 : 1;
            }
            if (nameASecondary > nameBSecondary) {
              return payload.orderSecondary == "asc" ? 1 : -1;
            }
          }

          return 0;
        });
      }
    },
    arrayUnique(array) {
      var a = array.concat();
      for (var i = 0; i < a.length; ++i) {
        for (var j = i + 1; j < a.length; ++j) {
          if (a[i] === a[j]) a.splice(j--, 1);
        }
      }

      return a;
    },
    filterVehicles() {
      var $_vehicles = [];
      var $_stockWildcard = [];

      var $yearrange = this.parse_range(this.options["year"], true);
      var $pricerange = this.parse_range(this.options["price"], true);
      var $mileagerange = this.parse_range(this.options["mileage"], true);
      var $statusrange = this.parse_range(this.options["status"]);
      var $makerange = this.parse_range(this.options["make"]);
      var $modelrange = this.parse_range(this.options["model"]);
      var $trimrange = this.parse_range(this.options["trim"]);
      var $typerange = this.parse_range(this.options["type"]);
      var $stockrange = this.parse_range(this.options["stock"]);
      var $tagsrange = this.parse_range(this.options["tags"]);
      var $flags = this.parse_range(this.options["flags"]);
      var $exclude_tags = this.parse_range(this.options['exclude_tags']);
      var $fueltyperange = this.optional_range(this.options["fueltype"]);
      var $drivetrainrange = this.optional_range(this.options["drivetrain"]);
      var $transmissionrange = this.optional_range(this.options["transmission"]);

      $stockrange.forEach((element) => {
        if (element.includes("*")) {
          $_stockWildcard.push(element.replace("*", ""));
        }
      });

      Object.values(this.inventory).forEach((vehicle) => {
        this.vehicleMatcher.vehicle = vehicle;
        var $is_match =
          this.vehicleMatcherMatch("year", $yearrange) &&
          this.vehicleMatcherMatch("make", $makerange) &&
          this.vehicleMatcherMatch("model", $modelrange) &&
          this.vehicleMatcherMatch("trim", $trimrange) &&
          this.vehicleMatcherMatch("price", $pricerange) &&
          this.vehicleMatcherMatch("mileage", $mileagerange) &&
          this.vehicleMatcherMatch("type", $typerange) &&
          this.vehicleMatcherMatchOptional("fueltype", $fueltyperange) &&
          this.vehicleMatcherMatchOptional("drivetrain", $drivetrainrange) &&
          this.vehicleMatcherMatchOptional("transmission", $transmissionrange) &&
          this.vehicleMatcherMatch("condition", $statusrange, "status") &&
          this.vehicleMatcherMatch("stocknumber",$stockrange,"stock",$_stockWildcard) &&
          this.vehicleMatcherMatchAny("tags", $tagsrange) &&
          this.vehicleMatcherNoTags($exclude_tags) &&
          this.vehicleMatcherMatchFlags($flags);

        if ($is_match) {
          $_vehicles.push(vehicle);
        }
      });

      this.inventory = $_vehicles;
    },
    parse_range($value, $evaluateHyphen = false) {
      var $range = [];

      if ($value != "all") {
        if ($evaluateHyphen && $value.indexOf("-") !== -1) {
          $range = $value.split("-");
          $range = this.range($range[1] - $range[0], $range[0]);
        } else if ($value.indexOf(",") !== -1) {
          $range = $value.split(",");
        } else {
          $range = [$value];
        }
      }

      return $range;
    },
    optional_range($value) {
      if (typeof $value !== "string") return [];
      return this.parse_range($value)
        .map(($item) => String($item).trim().toLowerCase())
        .filter(($item) => $item !== "");
    },
    vehicleMatcherMatchOptional($property, $values) {
      if (!$values.length) return true;
      var $vehicle = this.vehicleMatcher.vehicle || {};
      var $value = $vehicle[$property] == null ? "" : $vehicle[$property];
      return $values.includes(String($value).trim().toLowerCase());
    },
    range(size, startAt = 0) {
      var range = [];
      for (var i = 0; i <= size; i++) {
        range.push(startAt.toString() || startAt);
        startAt++;
      }
      return range;
    },
    vehicleMatcherNoTags($tags) {
      if (($tags.length === 0) || ($tags.length === 1 && $tags[0] == "")) {
        return true;
      }
    
      if (this.vehicleMatcher.vehicle.tags === undefined || this.vehicleMatcher.vehicle.tags === null) {
        return true; 
      }
    
      for (var i = 0; i < $tags.length; i++) {
        if (this.vehicleMatcher.vehicle.tags.indexOf($tags[i]) !== -1) {
          return false; 
        }
      }
    
      return true;
    },
    vehicleMatcherMatch(
      $property,
      $values,
      $propertyOptions = null,
      $stockWildcard = null
    ) {
      $propertyOptions = $propertyOptions || $property;
      var $value =
        this.vehicleMatcher.vehicle && this.vehicleMatcher.vehicle[$property]
          ? this.vehicleMatcher.vehicle[$property]
          : "";
      var $findWildcard = false;
      if ($propertyOptions == "stock") {
        if ($stockWildcard) {
          if ($stockWildcard.length > 0) {
            $stockWildcard.forEach((element) => {
              if ($value.includes(element)) {
                $findWildcard = true;
              }
            });
          }
        }
      }
      if ($findWildcard == true) {
        return true;
      } else {
        return (
          this.options[$propertyOptions] == "all" ||
          $values.includes($value.toString() || parseFloat($value))
        );
      }
    },
    vehicleMatcherMatchAny(
      $property,
      $values,
      $delimiter = ",",
      $propertyOptions = null
    ) {
      $propertyOptions = $propertyOptions || $property;

      if (this.options[$propertyOptions] == "all") {
        return true;
      }
      var $arrayValue = (this.vehicleMatcher.vehicle[$property] || "").split(
        $delimiter
      );

      for (var i = 0; i < $arrayValue.length; i++) {
        if ($values.includes($arrayValue[i])) return true;
      }
      return false;
    },
    vehicleMatcherMatchFlags($flags) {
      if ($flags.length === 0) {
        return true;
      }

      if ($flags.length === 1 && $flags[0] == "none") {
        return true;
      }

      var ret = true;

      for (var i = 0; i < $flags.length; i++) {
        if (
          !this.vehicleMatcher.vehicle[$flags[i]] &&
          $flags[i] != "excludeincoming" &&
          $flags[i] != "excludesalepending" &&
          $flags[i] != "excludedemo" &&
          $flags[i] != "excludecertified"
        ) {
          ret = false;
        } else if (
          $flags[i] == "excludeincoming" &&
          this.vehicleMatcher.vehicle["incoming"]
        ) {
          ret = false;
        } else if (
          $flags[i] == "excludesalepending" &&
          this.vehicleMatcher.vehicle["salepending"]
        ) {
          ret = false;
        } else if (
          $flags[i] == "excludedemo" &&
          this.vehicleMatcher.vehicle["demo"]
        ) {
          ret = false;
        } else if (
          $flags[i] == "excludecertified" &&
          this.vehicleMatcher.vehicle["certified"]
        ) {
          ret = false;
        }
      }

      return ret;
    },
    isEmpty(val) {
      return val === undefined || val == null || val.length <= 0 ? true : false;
    },
    string_contains_value(text, filter) {
      var array = filter.toLowerCase().split("_");
      var total_words = array.length;
      var vehicle = text.split(" ").map((item) => {
        return item.toLowerCase();
      });
      var total_coincidences = 0;
      array.forEach((item) => {
        var total_i = vehicle.filter((span) => {
          return span.includes(item);
        }).length;

        var total_p = vehicle.filter((span) => {
          return span.replace(/-/g, "").includes(item.replace(/-/, ""));
        }).length;

        if (total_i > 0 || total_p > 0) total_coincidences++;
      });

      if (total_words == total_coincidences) {
        return true;
      } else {
        return false;
      }
    },
    postFilterInventory(initialInventory, payload) {
      var stockNumber = payload.stockNumber;
      var vin = payload.vin || "";
      // Normalize VIN list once (lowercase, strip spaces/dashes). Supports comma-separated
      // values like ?filter_vin=VIN1,VIN2 — match passes if item.vin contains ANY needle.
      var vinList = vin
        ? vin.split(',').map(function (v) { return v.trim().toLowerCase().replace(/[\s-]/g, ''); }).filter(Boolean)
        : [];
      var mileageRange = payload.mileageRange;
      var priceRange = payload.priceRange;
      var filterValue = payload.filterValue;
      var selected = payload.selected;
      var dryweightRange = payload.dryweightRange;
      var grossweightRange = payload.grossweightRange;
      var sleepcapacityRange = payload.sleepcapacityRange;

      var filteredInventory = [];
      Object.values(initialInventory).forEach((item) => {
        var super_string =
          (item["condition"] && this.isEmpty(item["condition"])
            ? " "
            : item["condition"] || "" + " ") +
          (item["stocknumber"] && this.isEmpty(item["stocknumber"])
            ? " "
            : item["stocknumber"] || "" + " ") +
          (item["year"] && this.isEmpty(item["year"])
            ? " "
            : item["year"] || "" + " ") +
          (item["make"] && this.isEmpty(item["make"])
            ? " "
            : item["make"] || "" + " ") +
          (item["lot"] && this.isEmpty(item["lot"])
            ? " "
            : item["lot"] || "" + " ") +
          (item["model"] && this.isEmpty(item["model"])
            ? " "
            : item["model"] + "s" || "" + " ") +
          (item["type"] && this.isEmpty(item["type"])
            ? " "
            : item["type"] || "" + " ") +
          (item["subtype"] && this.isEmpty(item["subtype"])
            ? " "
            : item["subtype"] || "" + " ") +
          (item["trim"] && this.isEmpty(item["trim"])
            ? " "
            : item["trim"] || "" + " ") +
          (item["bodystyle"] && this.isEmpty(item["bodystyle"])
            ? " "
            : item["bodystyle"] || "" + " ") +
          (item["salepending"] && this.isEmpty(item["salepending"])
            ? " "
            : item["salepending"] || "" + " ") +
          (item["price"] && this.isEmpty(item["price"])
            ? " "
            : item["price"] || "" + " ") +
          (item["mileage"] && this.isEmpty(item["mileage"])
            ? " "
            : item["mileage"] || "" + " ") +
          (item["exteriorcolor"] && this.isEmpty(item["exteriorcolor"])
            ? " "
            : item["exteriorcolor"] || "" + " ") +
          (item["dryweight"] && this.isEmpty(item["dryweight"])
            ? " "
            : item["dryweight"] || "" + " ") +
          (item["grossweight"] && this.isEmpty(item["grossweight"])
            ? " "
            : item["grossweight"] || "" + " ") +
          (item["sleepcapacity"] && this.isEmpty(item["sleepcapacity"])
            ? " "
            : item["sleepcapacity"] || "" + "  ") +
          (item["length"] && this.isEmpty(item["length"])
            ? " "
            : item["length"] || "" + " ") +
          (item["productline"] && this.isEmpty(item["productline"])
            ? " "
            : item["productline"] || "" + " ") +
          (item["vin"] && this.isEmpty(item["vin"])
            ? " "
            : item["vin"] || "" + " ");

        // condition
        if (
          item.condition &&
          selected.condition.length > 0 &&
          selected.condition
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.condition
                .replace(/ /g, "-")
                .replace(/-+/g, "-")
                .toLowerCase()
            ) == -1
        )
          return;
        if (!item.condition && selected.condition.length > 0) return;

        // Cab
        if (
          item.cab &&
          selected.cab.length > 0 &&
          selected.cab
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.cab
                .replace(/ /g, "-")
                .replace(/-+/g, "-")
                .toLowerCase()
            ) == -1
        )
          return;
        if (!item.cab && selected.cab.length > 0) return;

        // year
        if (
          item.year &&
          selected.year.length > 0 &&
          selected.year.indexOf(item.year) == -1
        )
          return;
        if (!item.year && selected.year.length > 0) return;

        // make
        if (
          item.make &&
          selected.make.length > 0 &&
          selected.make
            .map((item) => {
              return item.replace(/ /g, "-").toLowerCase();
            })
            .indexOf(item.make.replace(/ /g, "-").toLowerCase()) == -1
        )
          return;
        if (!item.make && selected.make.length > 0) return;

        // Lot
        if (
          item.lot &&
          selected.lot.length > 0 &&
          selected.lot
            .map((item) => {
              return item.replace(/ /g, "-").toLowerCase();
            })
            .indexOf(item.lot.replace(/ /g, "-").toLowerCase()) == -1
        )
          return;
        if (!item.lot && selected.lot.length > 0) return;

        // stock
        if (
          item.stocknumber &&
          selected.stock.length > 0 &&
          selected.stock
            .map((item) => {
              return item.replace(/ /g, "-").toLowerCase();
            })
            .indexOf(item.stocknumber.replace(/ /g, "-").toLowerCase()) == -1
        )
          return;
        if (!item.stocknumber && selected.stock.length > 0) return;

        // type
        if (
          item.type &&
          selected.type.length > 0 &&
          selected.type
            .map((item) => {
              return item.toUpperCase();
            })
            .indexOf(item.type.toUpperCase()) == -1
        )
          return;
        if (!item.type && selected.type.length > 0) return;

        // subtype
        if (
          item.subtype &&
          selected.subtype.length > 0 &&
          selected.subtype
            .map((item) => {
              return item.toLowerCase();
            })
            .indexOf(item.subtype.toLowerCase()) == -1
        )
          return;
        if (!item.subtype && selected.subtype.length > 0) return;

        // productline
        if (
          item.productline &&
          selected.productline.length > 0 &&
          selected.productline
            .map((item) => {
              return item.toLowerCase();
            })
            .indexOf(item.productline.toLowerCase()) == -1
        )
          return;
        if (!item.productline && selected.productline.length > 0) return;

        // length
        if (
          item["length"] &&
          selected.outsidelength.length > 0 &&
          item.length &&
          selected.outsidelength
            .map((item) => {
              return item.toLowerCase();
            })
            .indexOf(item["length"].toLowerCase()) == -1
        )
          return;
        if (!item["length"] && selected.outsidelength.length > 0) return;

        // floorplantags
        if (item.floorplantags && selected.floorplan.length > 0) {
          var intersection = selected.floorplan.filter((o) =>
            item.floorplantags.includes(o)
          );
          if (intersection.length < selected.floorplan.length) return;
        }
        if (!item.floorplantags && selected.floorplan.length > 0) return;

        // model
        if (
          item.model &&
          selected.model.length > 0 &&
          selected.model
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.model
                ? item.model
                    .replace(/ /g, "-")
                    .replace(/-+/g, "-")
                    .toLowerCase()
                : ""
            ) == -1
        ) {
          return;
        }
        if (!item.model && selected.model.length > 0) return;

        // trim
        if (
          item.trim &&
          selected.trim.length > 0 &&
          selected.trim
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.trim
                ? item.trim.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase()
                : ""
            ) == -1
        )
          return;
        if (!item.trim && selected.trim.length > 0) return;

        // exteriorcolor
        if (
          item.exteriorcolor &&
          selected.colour.length > 0 &&
          selected.colour
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.exteriorcolor
                ? item.exteriorcolor
                    .replace(/ /g, "-")
                    .replace(/-+/g, "-")
                    .toLowerCase()
                : ""
            ) == -1
        )
          return;
        if (!item.exteriorcolor && selected.colour.length > 0) return;

        // transmission
        if (
          item.transmission &&
          selected.transmission.length > 0 &&
          selected.transmission.indexOf(item.transmission) == -1
        )
          return;
        if (!item.transmission && selected.transmission.length > 0) return;

        // drivetrain
        if (
          item.drivetrain &&
          selected.drivetrain.length > 0 &&
          selected.drivetrain.indexOf(item.drivetrain.toUpperCase()) == -1
        )
          return;
        if (!item.drivetrain && selected.drivetrain.length > 0) return;

        // STATUS
        if (
          item.incoming &&
          selected.status.length > 0 &&
          selected.status
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf("incoming") == -1
        )
          return;

        if (
          !item.incoming &&
          selected.status.length > 0 &&
          selected.status
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf("in-stock") == -1
        )
          return;

        //Salepending
        if (
          item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("1") == false
        )
          return;

        if (
          !item.salepending &&
          selected.salepending.length > 0 &&
          selected.salepending.includes("0") == false
        )
          return;

        // engine displacement
        if (
          item.enginedisplacement &&
          selected.enginedisplacement.length > 0 &&
          selected.enginedisplacement.indexOf(
            item.enginedisplacement.toString()
          ) == -1
        )
          return;
        if (!item.enginedisplacement && selected.enginedisplacement.length > 0)
          return;

        // bodystyle
        if (
          item.bodystyle &&
          selected.bodystyle.length > 0 &&
          selected.bodystyle
            .map((item) => {
              return item.replace(/ /g, "-").replace(/-+/g, "-").toLowerCase();
            })
            .indexOf(
              item.bodystyle
                ? item.bodystyle
                    .replace(/ /g, "-")
                    .replace(/-+/g, "-")
                    .toLowerCase()
                : ""
            ) == -1
        )
          return;
        if (!item.bodystyle && selected.bodystyle.length > 0) return;

        //  stocknumber
        if (item.stocknumber && stockNumber.length > 0) {
          var stockNExploded = stockNumber
            .split(",")
            .map((i) => i.toLowerCase());

          if (!stockNExploded.includes(item.stocknumber.toLowerCase())) return;
        }

        // vin (substring match against any needle in vinList, case-insensitive,
        // ignores spaces and dashes). vinList is empty when no VIN filter is active.
        if (vinList.length > 0) {
          if (!item.vin) return;
          var itemVin = String(item.vin).toLowerCase().replace(/[\s-]/g, '');
          if (!vinList.some(function (needle) { return itemVin.indexOf(needle) !== -1; })) return;
        }

        // price
        if (
          item.price &&
          !(item.price >= priceRange[0] && item.price <= priceRange[1])
        )
          return;
        if (
          !item.price &&
          (priceRange[0] > payload.minPrice || priceRange[1] < payload.maxPrice)
        )
          return;

        // mileage
        if (
          item.mileage &&
          !(item.mileage >= mileageRange[0] && item.mileage <= mileageRange[1])
        )
          return;
        if (
          !item.mileage &&
          (mileageRange[0] > payload.minMileage ||
            mileageRange[1] < payload.maxMileage)
        )
          return;

        // dryweight
        if (
          item.dryweight &&
          !(
            item &&
            item.dryweight != undefined &&
            item.dryweight != null &&
            parseInt(item.dryweight) >= parseInt(dryweightRange[0]) &&
            parseInt(item.dryweight) <= parseInt(dryweightRange[1])
          )
        )
          return;
        if (
          !item.dryweight &&
          (dryweightRange[0] > payload.minDryweight ||
            dryweightRange[1] < payload.maxDryweight)
        )
          return;

        // grossweight
        if (
          item.grossweight &&
          !(
            item &&
            item.grossweight != undefined &&
            item.grossweight != null &&
            parseInt(item.grossweight) >= parseInt(grossweightRange[0]) &&
            parseInt(item.grossweight) <= parseInt(grossweightRange[1])
          )
        )
          return;
        if (
          !item.grossweight &&
          (grossweightRange[0] > payload.minGrossweight ||
            grossweightRange[1] < payload.maxGrossweight)
        )
          return;

        // sleepcapacity
        if (
          item.sleepcapacity &&
          !(
            item &&
            item.sleepcapacity != undefined &&
            item.sleepcapacity != null &&
            parseInt(item.sleepcapacity) >= parseInt(sleepcapacityRange[0]) &&
            parseInt(item.sleepcapacity) <= parseInt(sleepcapacityRange[1])
          )
        )
          return;
        if (
          !item.sleepcapacity &&
          (sleepcapacityRange[0] > payload.minSleepcapacity ||
            sleepcapacityRange[1] < payload.maxSleepcapacity)
        )
          return;

        // superstring
        if (
          filterValue.length > 0 &&
          !this.string_contains_value(
            super_string,
            filterValue.replace(/ /g, "_")
          )
        )
          return;

        // searchablesarray
        if (item.searchablesarray && selected.feature.length > 0) {
          var featintersection = selected.feature.filter((o) =>
            item.searchablesarray
              .map((sa) => sa.replace(/ /g, "-").toLowerCase())
              .includes(o.replace(/ /g, "-").toLowerCase())
          );
          if (featintersection.length < selected.feature.length) return;
        }
        if (!item.searchablesarray && selected.feature.length > 0) return;

        // searchables
        if (item.searchables && selected.package.length > 0) {
          var searchablesExploded = item.searchables
            .split(",")
            .map((i) => i.toLowerCase());
          var packintersection = selected.package
            .map((i) => i.toLowerCase())
            .filter((o) => searchablesExploded.includes(o));

          if (!packintersection.length) return;
        }
        if (!item.searchables && selected.package.length > 0) return;

        // engine
        if (
          item.engine &&
          selected.engine.length > 0 &&
          selected.engine.indexOf(item.engine.toUpperCase()) == -1
        ) {
          return;
        }
        if (!item.engine && selected.engine.length > 0) return;

        // location
        if (
          item.location &&
          selected.location.length > 0 &&
          selected.location.indexOf(item.location.toUpperCase()) == -1
        )
          return;
        if (!item.location && selected.location.length > 0) return;

        filteredInventory.push(item);
      });
      return filteredInventory;
    },
    getJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();
      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);
        if (minutesDifference <= minutes) {
          return lastUpdateDate;
        } else {
          sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
          return currentDate;
        }
      } else {
        sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
        return currentDate;
      }
    },
    needsUpdateJSONTimestamp(minutes, name) {
      let lastTimestamp = sessionStorage.getItem("lastUpdate" + name + "JSON");
      let currentDate = new Date();

      if (lastTimestamp) {
        var lastUpdateDate = new Date(lastTimestamp * 1000);
        let minutesDifference = (currentDate - lastUpdateDate) / (60 * 1000);

        console.warn("LBX: Minutes Difference --> ", minutesDifference);
        if (minutesDifference <= minutes) {
          return false;
        } else {
          sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
          return true;
        }
      } else {
        console.warn("LBX: lastUpdate session storage not found");
        sessionStorage.setItem("lastUpdate" + name + "JSON",Math.floor(currentDate / 1000));
        return false;
      }
    },
  },
  mounted() {},
});
export default EventBus;
